(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
function updatePrices() {
    const qtyInputEl = document.querySelector('input[name="quantity"]'); 
    const qty = parseFloat(qtyInputEl?.value || 1);
 
    const selectedRow = document.querySelector('.oscp-active tr.selected'); 
    if (!selectedRow) return; // No selected row found
 
    const prices = selectedRow.querySelectorAll('.dualPrice');
    if (prices.length < 2) return; // Need at least 2 prices
 
    // Extract currency symbol and spacing
    const originalPriceText = prices[0].textContent.trim();
    const currencySymbol = originalPriceText.match(/[^\d.,]+/g)?.[0] || '';
    const spaceBefore = originalPriceText.startsWith(currencySymbol) ? '' : ' ';
    const spaceAfter = originalPriceText.endsWith(currencySymbol) ? ' ' : '';
 
    const price1 = parseFloat(originalPriceText.replace(currencySymbol, '').replace(',', '.').trim());
    const price2 = parseFloat(prices[1].textContent.replace(currencySymbol, '').replace(',', '.').trim());
 
    // Preise berechnen
    const total2 = price2 * qty;            // exkl. USt (Netto)
    const total1 = total2 * 1.19;           // inkl. 19% USt (Brutto)
 
    // Stückpreise berechnen
    const perUnit2 = total2 / qty;          // Netto pro Stück
    const perUnit1 = perUnit2 * 1.19;       // Brutto pro Stück
 
    const formatPrice = (value) => 
        `${spaceBefore}${currencySymbol}${spaceAfter}${value.toFixed(2).replace('.', ',')}`;
 
    const priceContainer = document.querySelector('[ref="priceContainer"]');
    if (priceContainer) {
        priceContainer.innerHTML = `
            <span class="price">
                <span class="dualPrice">
                    ${formatPrice(total2)} 
                    <span style="font-size: 16px; font-weight: 400;">
                        (${formatPrice(perUnit2)}/Stück)
                    </span>
                </span>
                <span style="font-size: 16px; font-weight: 400;">exkl. 19% USt.</span>
            </span>
            <span style="display: block; font-size: 24px; color: #858586">
                <span class="dualPrice">
                    ${formatPrice(total1)} 
                    <span style="font-size: 16px; color:#777; font-weight: 400;">
                        (${formatPrice(perUnit1)}/Stück)
                    </span>
                </span>
                <span style="font-size: 16px; font-weight: 400;">inkl. 19% USt.</span>
            </span>
        `;
    }
}
 
// Update when quantity changes
document.querySelector('input[name="quantity"]').addEventListener('change', () => {
    setTimeout(updatePrices, 50);
});
 
// Update when a table row is clicked
document.querySelectorAll('.oscp-active tr').forEach(row => {
    row.addEventListener('click', () => {
        setTimeout(updatePrices, 50);
    });
});
 
// Update when any ".button-unstyled" button is clicked
document.querySelectorAll('.button-unstyled').forEach(button => {
    button.addEventListener('click', () => {
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        setTimeout(updatePrices, 50);
    });
});

  } catch(e) { console.error(e); }
})();
})();
